module.exports = __webpack_public_path__ + "razorpay-d6a11fbefa3e2cb96cf7.svg";